"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidWhiteSpacesOnly = exports.isNoWhiteSpacesAtStartOrEnd = exports.isNotMultipleWhitespace = exports.isNotEmptyString = exports.isNumberWithinDecimalPlaces = exports.isAllowedAccountNameCharsOnly = exports.isNoWhitespace = exports.isAllowedCompanyNameCharsOnly = exports.isAllowedSingleLineCharsOnly = exports.isAllowedMultiLineCharsOnly = exports.doesInputExceedMaxLength = void 0;
const common_1 = require("../common");
const regex_1 = require("./regex");
const validationConsts_1 = require("./validationConsts");
const doesInputExceedMaxLength = (val) => !(0, common_1.isAtMostNChar)(val, validationConsts_1.MAX_INPUT_LENGTH);
exports.doesInputExceedMaxLength = doesInputExceedMaxLength;
const isAllowedMultiLineCharsOnly = (val) => val && regex_1.allowListMultiLineCharRegex.test(val);
exports.isAllowedMultiLineCharsOnly = isAllowedMultiLineCharsOnly;
const isAllowedSingleLineCharsOnly = (val) => val && regex_1.allowListSingleLineCharRegex.test(val);
exports.isAllowedSingleLineCharsOnly = isAllowedSingleLineCharsOnly;
const isAllowedCompanyNameCharsOnly = (val) => val && regex_1.allowListCompanyNameCharRegex.test(val);
exports.isAllowedCompanyNameCharsOnly = isAllowedCompanyNameCharsOnly;
const isNoWhitespace = (val) => val && regex_1.textNoWhiteSpacesRegex.test(val);
exports.isNoWhitespace = isNoWhitespace;
const isAllowedAccountNameCharsOnly = (val) => val && regex_1.allowListAccountNameCharRegex.test(val);
exports.isAllowedAccountNameCharsOnly = isAllowedAccountNameCharsOnly;
const isNumberWithinDecimalPlaces = (val, decimalPlaces) => val.toString().length <= val.toFixed(decimalPlaces).length;
exports.isNumberWithinDecimalPlaces = isNumberWithinDecimalPlaces;
const isNotEmptyString = (val) => val && val.trim() !== "";
exports.isNotEmptyString = isNotEmptyString;
const isNotMultipleWhitespace = (val) => val && !regex_1.textMultipleWhiteSpace.test(val);
exports.isNotMultipleWhitespace = isNotMultipleWhitespace;
const isNoWhiteSpacesAtStartOrEnd = (val) => val && val === val.trim();
exports.isNoWhiteSpacesAtStartOrEnd = isNoWhiteSpacesAtStartOrEnd;
const isValidWhiteSpacesOnly = (val) => (0, exports.isNoWhiteSpacesAtStartOrEnd)(val) && (0, exports.isNotMultipleWhitespace)(val) && (0, exports.isNotEmptyString)(val);
exports.isValidWhiteSpacesOnly = isValidWhiteSpacesOnly;
